<template>
    <div class="modal-container">
        <div class="modal show" :class="classes">
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                :class="modalSize"
            >
                <component v-bind="args" :is="selectedModal" />
            </div>
        </div>
        <div class="modal-backdrop show" />
    </div>
</template>

<script>
import ModalPromoAccept from '@/components/modals/ModalPromoAccept.vue'
import ModalSendLabels from '@/components/modals/ModalSendLabels.vue'
import HappyHours from '@/components/modals/HappyHours.vue'
import StopPromotion from '@/components/modals/StopPromotion.vue'
import AcceptService from '@/components/modals/AcceptService.vue'
import CancelService from '@/components/modals/CancelService.vue'
import ModalLabels from '@/components/modals/ModalLabels.vue'
import ModalAlerts from '@/components/modals/ModalAlerts.vue'
import GenerateLabels from '@/components/modals/GenerateLabels.vue'
import ModalSettlementsProcess from '@/components/settlements/ModalProcess.vue'
import ModalConsent from '@/components/settings/ModalConsent.vue'
import ModalCookies from '@/components/modals/ModalCookies.vue'
import PromotionInfographicPreview from '@/components/modals/PromotionInfographicPreview.vue'
import PrivacyPolicy from '@/components/modals/PrivacyPolicy.vue'
import AddStoresToNetwork from '@/components/modals/AddStoresToNetwork.vue'
import ConsentsModal from '@/components/modals/ConsentsModal.vue'
import LotteryNewUserModals from '@/components/modals/LotteryNewUserModals.vue'
import AcceptanceAllGroupModal from '@/components/modals/AcceptanceAllGroupModal.vue'
import EditStoreUser from '@/components/modals/EditStoreUser'
import DeleteStoreUser from '@/components/modals/DeleteStoreUser'
import ModalShopPrices from '@/components/modals/ModalShopPrices'
import AddPromoSelectionProducts from '@/components/modals/AddPromoSelectionProducts'
import MerchantEanSelectionProducts from '@/components/modals/MerchantEanSelectionProducts'
import ProductPrices from '@/components/modals/ProductPrices'
import ProductSetPrices from '@/components/modals/ProductSetPrices'
import ModalAddPromoSummary from '@/components/modals/ModalAddPromoSummary'
import ModalExportFiles from '@/components/modals/ModalExportFiles'
import EditOpeningHours from '../../modals/EditOpeningHours'
import DownloadGroupAttachments from '@/components/modals/DownloadGroupAttachments'
import AlternativeEans from '@/components/modals/AlternativeEans'
import ModalEditPromoSummary from '@/components/modals/ModalEditPromoSummary'
import AddPromoChangedProducts from '@/components/modals/AddPromoChangedProducts'

import { modalMixin } from '@/mixins/modal'

export default {
    mixins: [modalMixin],

    components: {
        ModalPromoAccept,
        ModalSendLabels,
        HappyHours,
        StopPromotion,
        AcceptService,
        CancelService,
        ModalLabels,
        ModalAlerts,
        ModalSettlementsProcess,
        GenerateLabels,
        ModalConsent,
        ModalCookies,
        PrivacyPolicy,
        PromotionInfographicPreview,
        AddStoresToNetwork,
        ConsentsModal,
        LotteryNewUserModals,
        AcceptanceAllGroupModal,
        EditStoreUser,
        ModalShopPrices,
        AddPromoSelectionProducts,
        MerchantEanSelectionProducts,
        ProductPrices,
        ProductSetPrices,
        ModalAddPromoSummary,
        DeleteStoreUser,
        ModalExportFiles,
        EditOpeningHours,
        DownloadGroupAttachments,
        AlternativeEans,
        ModalEditPromoSummary,
        AddPromoChangedProducts
    },
    computed: {
        selectedModal() {
            return this.$store.getters.modalState.content
        },
        classes() {
            return this.$store.getters.modalState.classes
        },
        args() {
            return this.$store.getters.modalState.args
        },
        modalSize() {
            return this.args?.modalSize || 'modal-lg'
        }
    }
}
</script>
